module.exports = __webpack_public_path__ + "img/mannul_transactions_export-excel.73585ada.png";